import React, { FC } from 'react';
import { SafeHtml } from 'ia-react-core';
import { getHostName } from 'omni-package-react-cms';
import { StyledSafeHtml, StyledMessageBox, StyledTitle, StyledWarningMessage } from './MessageList.styles';
import { WarningMessage } from '../../../../interfaces/WarningMessage';

export interface MessageListProps {
  messages: WarningMessage[];
}

const MessageList: FC<MessageListProps> = ({ messages }) => {
  const containsATitle = messages.filter((msg) => msg.title).length > 0;
  return (
    <StyledWarningMessage>
      {messages.map((msg, index) => {
        const htmlContent = msg.message?.replace(/src="(?:\/cw\/)?-\/media\/(.*)"/, `src="${getHostName()}/cw/-/media/$1"`);
        return (
          <StyledMessageBox withSeparator={index > 0} key={index}>
            {msg.title && <StyledTitle>{msg.title}</StyledTitle>}
            {containsATitle ? <SafeHtml addTags={['img']} addAttr={['src']}>{htmlContent}</SafeHtml> : <StyledSafeHtml addTags={['img']} addAttr={['src']}>{htmlContent}</StyledSafeHtml>}
          </StyledMessageBox>
        );
      })}
    </StyledWarningMessage>
  );
};

export default MessageList;
